import {Routes} from '@angular/router';
import {RouterModule} from '@angular/router';
import {NgModule} from '@angular/core';
import {PortalService} from '../services/portal.service';
import {StepChapterComponent} from '../step/step.chapter.component';
import {EingabeStartComponent} from './eingabe/eingabe.start.component';
import {EingabeStepComponent} from './eingabe/eingabe.step.component';
import {ErgebnisComponent} from './ergebnis/ergebnis.component';
import {WpcheckAusstiegComponent} from './eingabe/wpcheck.ausstieg.component';
import {EinstiegComponent} from "./einstieg/einstieg.component";

/**
 * Routes for the wpcheck.
 * The default route leads to wpcheck here
 */
const routes: Routes = [
  {
    path: ':portalId/wpcheck', children: [
      // default step is 'eingabe'
      {path: '', redirectTo: 'start', pathMatch: 'full'},
      // list of all available steps in the advisor
      // first input section
      {path: 'kurz', component: EinstiegComponent},
      {path: 'start', component: EingabeStartComponent},
      {path: 'eingabe/start', redirectTo: 'start', pathMatch: 'full'},

      {
        path: 'eingabe', component: StepChapterComponent, children: [
          {path: 'basisinformationen/1', component: EingabeStepComponent, data: {swipeCount: '20'}},
          {path: 'basisinformationen/2', component: EingabeStepComponent, data: {swipeCount: '30'}},
          {path: 'basisinformationen/3', component: EingabeStepComponent, data: {swipeCount: '40'}},
          {path: 'basisinformationen/4', component: EingabeStepComponent, data: {swipeCount: '50'}},
          {path: 'basisinformationen/5', component: EingabeStepComponent, data: {swipeCount: '60'}},
          {path: 'basisinformationen/6', component: EingabeStepComponent, data: {swipeCount: '70'}},
          {path: 'basisinformationen/7', component: EingabeStepComponent, data: {swipeCount: '80'}},
          {path: 'basisinformationen/8', component: EingabeStepComponent, data: {swipeCount: '90'}},
          {path: 'basisinformationen/9', component: EingabeStepComponent, data: {swipeCount: '100'}},
          {path: 'basisinformationen/10', component: EingabeStepComponent, data: {swipeCount: '110'}},
          {path: 'basisinformationen/11', component: EingabeStepComponent, data: {swipeCount: '120'}},
          {path: 'basisinformationen/12', component: EingabeStepComponent, data: {swipeCount: '130'}},
          {path: 'basisinformationen/13', component: EingabeStepComponent, data: {swipeCount: '140'}},
          {path: 'basisinformationen/14', component: EingabeStepComponent, data: {swipeCount: '150'}},
          {path: 'heizung-und-wasser/1', component: EingabeStepComponent, data: {swipeCount: '160'}},
          {path: 'heizung-und-wasser/2', component: EingabeStepComponent, data: {swipeCount: '170'}},
          {path: 'heizung-und-wasser/3', component: EingabeStepComponent, data: {swipeCount: '180'}},
          {path: 'heizung-und-wasser/4', component: EingabeStepComponent, data: {swipeCount: '190'}},
          {path: 'heizung-und-wasser/5', component: EingabeStepComponent, data: {swipeCount: '200'}},
          {path: 'heizung-und-wasser/6', component: EingabeStepComponent, data: {swipeCount: '210'}},
          {path: 'massnahmen/1', component: EingabeStepComponent, data: {swipeCount: '220'}},
          {path: 'massnahmen/2', component: EingabeStepComponent, data: {swipeCount: '230'}},
          {path: 'massnahmen/3', component: EingabeStepComponent, data: {swipeCount: '240'}},
          {path: 'massnahmen/4', component: EingabeStepComponent, data: {swipeCount: '250'}},
          {path: 'massnahmen/5', component: EingabeStepComponent, data: {swipeCount: '260'}},
          {path: 'ausstieg', component: WpcheckAusstiegComponent, data: {swipeCount: '270', ignoreInNav: true, isDeadEnd: true}},
          {path: '', redirectTo: 'basisinformationen/1', pathMatch: 'full'},
        ]
      },
      // last section with result page
      {
        path: 'ergebnis', component: StepChapterComponent, children: [
          {path: 'analyse', component: ErgebnisComponent, data: {swipeCount: '1000', advisor: 'wpcheck'}},
          {path: '', redirectTo: 'analyse', pathMatch: 'full'},
        ]
      },
    ]
  },
  {path: ':portalId', redirectTo: PortalService.defaultPortal + '/wpcheck', pathMatch: 'full'},
  {path: 'wpcheck/', redirectTo: PortalService.defaultPortal + '/wpcheck', pathMatch: 'full'},
  {path: '', redirectTo: PortalService.defaultPortal + '/wpcheck', pathMatch: 'full'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    anchorScrolling: 'enabled',
    scrollOffset: [0, 150],
    paramsInheritanceStrategy: 'always'
})],
  exports: [RouterModule]
})
export class WpcheckRoutingModule {
}
